module.exports = __webpack_public_path__ + "static/media/2_The inner voice_EN.6ccd729f.txt";